// extracted by mini-css-extract-plugin
module.exports = {"topic":"AccountReview_topic__nngT7","boxWrapper":"AccountReview_boxWrapper__FgoIe"};